<script>
  import settings from '../config';
  import { t9n } from '../lib/translate';
  import { TS } from '../config/translation-keys';

  // component options  ------------------------------------------------------ //

  export let profile;
  export let order_uuid = null;
  export let order_status;

  let open_profile_label = t9n(TS.CHAT_OPEN_PROFILE);

  const profile_url = () => {
      return `${settings.api_host}/profile?order_uuid=${order_uuid}&user_id=${profile.id}`;
  }

  function handle_tooltip(event, text, id) {
      let aside_id = document.querySelector('#aside_tooltips');
      let new_tooltip = document.createElement('div');
      new_tooltip.style.position = 'absolute';
      new_tooltip.style.left = event.clientX + 'px';
      new_tooltip.style.top = event.clientY + 'px';
      new_tooltip.innerHTML = text;
      new_tooltip.style.zIndex = 999;
      new_tooltip.classList.add('md-tooltip', 'md-tooltip--right', 'md-' + id);
      aside_id.appendChild(new_tooltip);
      setTimeout(function() {
        new_tooltip.style.transform = 'scale(1)';
      }, 111);
  }

  function remove_tooltip(tooltip) {
    let aside_id = document.querySelector('#aside_tooltips');
    let to_delete = aside_id.querySelector('.md-' + tooltip);
    if (to_delete) {
      to_delete.remove();
    }
  }

</script>

<table class={`table user-header ${profile.message_role}`} style="order: -1; height: 173px">
  <tbody>
  <tr>
    <td>
    </td>

    {#if order_uuid && order_status !== 'order_status_completed' && order_status !== 'order_status_cancelled_by_worker' && order_status !== 'order_status_cancelled_by_orderer' && order_status !== 'order_status_cancelled_by_admin' }
      <td class="person-info pointer" colspan="2"
          on:click={() => window.open(profile_url())}
          on:mouseover={() => handle_tooltip(event, open_profile_label, 2)}
          on:mouseout={() => remove_tooltip(2)}
      >
        <div class="profile-link" style="position:relative;">
          <span id="profile_image" class="img-container slideInLeft">
              <img
                src={`${settings.api_host}${profile.image_url}`}
                alt="avatar"
                style="width: 80px ;height: 80px; border-radius: 50%; margin-top: 0.6em;"
              />
          </span>
          <h4 id="user_name" class="user-name slideInRight">{profile.name}</h4>
          <div id="user_info" class="user-info slideUp">{profile.message_role_translated}</div>
          <span class="material-icons" style="font-size: 15px; margin-left: 5px;">
            open_in_new
          </span>
        </div>
      </td>
    {:else}
      <td class="person-info" colspan="2">
        <div class="profile-link" style="position:relative;">
          <span id="profile_image" class="img-container slideInLeft">
              <img
                src={`${settings.api_host}${profile.image_url}`}
                alt="avatar"
                style="width: 80px ;height: 80px; border-radius: 50%; margin-top: 0.6em;"
              />
          </span>
          <h4 id="user_name" class="user-name slideInRight">{profile.name}</h4>
          <div id="user_info" class="user-info slideUp">{profile.message_role_translated}</div>
        </div>
      </td>
    {/if}

    <td>
    </td>
  </tr>
  </tbody>
</table>

<style>
    .user-name {
        text-transform: uppercase;
        font-weight: 500;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .user-info {
        font-size: 14px;
        display: inline-block;
    }

    .profile-link {
        text-decoration: none;

    }

    .pointer {
        cursor: pointer;
    }

    .table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        border-radius: 5px;
    }

    .orderer {
        background-color: var(--orderer-background-color);
        -webkit-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
        box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    }

    .worker {
        background-color: var(--worker-background-color);
        -webkit-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
        box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    }

    .applicant {
        background-color: var(--worker-background-color);
        -webkit-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
        box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    }

    .user-header {
        color: white;
        font-size: 14px;
        text-align: center;
    }

    .person-info {
        padding: 1em 0 2em;
    }
</style>
